module.exports = __webpack_public_path__ + "img/module3.cf9fddc.png";